import Config from '../../config';

import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchUserPrivileges = async userPrivilege => await fetch(
  Config.endpoints.FETCH_ROLE_USER_PRIVILEGES.replace(/:userPrivilege/, userPrivilege)
)
  .then(handleErrors({ errorMessage: 'Fetching user privileges failed.' }))
  .then(parseAsJson);

export const fetchCustomGroups = async () => await fetch(Config.endpoints.FETCH_CUSTOM_GROUPS)
  .then(handleErrors({ errorMessage: 'Fetching custom groups failed.' }))
  .then(parseAsJson);

export const fetchGroupItemTypes = ({ groupType }) => fetch(
  Config.endpoints.FETCH_CUSTOM_GROUP_ITEM_TYPES
    .replace(/:groupType/, groupType)
)
  .then(handleErrors({ errorMessage: 'Fetching group item types failed.' }))
  .then(parseAsJson);

export const fetchGroupItems = async groupType =>
  await fetch(Config.endpoints.FETCH_CUSTOM_GROUP_ITEMS.replace(/:groupType/, groupType))
    .then(handleErrors({ errorMessage: 'Fetching group items failed.' }))
    .then(parseAsJson);

export const deleteCustomGroup = async ({ groupId }) => await fetch(
  Config.endpoints.DELETE_CUSTOM_GROUP
    .replace(':groupId', groupId),
  {
    method: 'DELETE',
  }
).then(handleErrors({ errorMessage: 'Removing custom group failed' }));

export const editCustomGroup = async group => await fetch(
  Config.endpoints.EDIT_CUSTOM_GROUP,
  {
    method: 'POST',
    body: JSON.stringify(group),
  }
)
  .then(handleErrors({ errorMessage: 'Editing custom group failed' }))
  .then(parseAsJson);

export const saveNewCustomGroup = async group => await fetch(
  Config.endpoints.SAVE_NEW_CUSTOM_GROUP,
  {
    method: 'POST',
    body: JSON.stringify(group),
  }
)
  .then(handleErrors({ errorMessage: 'Creating custom group failed.' }))
  .then(parseAsJson);

export const refreshCustomGroupData = async () => await fetch(
  Config.endpoints.REFRESH_CUSTOM_GROUP_DATA,
  {
    method: 'GET',
  }
)
  .then(handleErrors({ errorMessage: 'Custom group data refresh failed' }));
